import { ScholarshipsDiscountsDataStore } from '../datastores/ScholarshipsDiscountsDataStore';
import { ScholarshipsDiscountsDataStoreFactory } from '../factories/ScholarshipsDiscountsFactory';

export default class ScholarshipsDataDiscountsRepository {
  getScholarshipsDiscounts() {
    const scholarshipsDiscountsDataStore: ScholarshipsDiscountsDataStore =
      ScholarshipsDiscountsDataStoreFactory.create();
    return scholarshipsDiscountsDataStore.getScholarshipsDiscounts();
  }

  getAgreementInfo(codigoTramite: number) {
    const scholarshipsDiscountsDataStore: ScholarshipsDiscountsDataStore =
      ScholarshipsDiscountsDataStoreFactory.create();
    return scholarshipsDiscountsDataStore.getAgreementInfo(codigoTramite);
  }

  registerAgreement(input: any) {
    const scholarshipsDiscountsDataStore: ScholarshipsDiscountsDataStore =
      ScholarshipsDiscountsDataStoreFactory.create();
    return scholarshipsDiscountsDataStore.registerAgreement(input);
  }

  getAgreementValidations(codigoTramite: number, dni: string): Promise<any> {
    const scholarshipsDiscountsDataStore: ScholarshipsDiscountsDataStore =
      ScholarshipsDiscountsDataStoreFactory.create();
    return scholarshipsDiscountsDataStore
      .getAgreementInfo(codigoTramite, dni)
      .then((response: any) => response.validations);
  }
}
